import axios from 'axios';
import { encriptar } from './encriptacion';
import Swal from 'sweetalert2';
const apiUrl = process.env.REACT_APP_API_URL
const tokenEncript = process.env.REACT_APP_CLAVE_INCRIPTACION
// Crear una instancia de axios
const api = axios.create({
  baseURL: apiUrl, // Reemplaza con tu URL base
  // timeout: 300000, // Tiempo máximo de espera
});

// Añadir un interceptor de solicitud
api.interceptors.request.use(
  config => {
    // Puedes añadir cabeceras o modificar la solicitud antes de enviarla
    const token = sessionStorage.getItem('token'); // O de donde guardes tu token
    if (token) {
      config.headers['Authorization'] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Añadir un interceptor de respuesta
api.interceptors.response.use(
  response => {
    // Puedes manejar la respuesta aquí, si todo está bien

    return response;
  },
  error => {
    // Manejar errores globalmente
    if (error.response) {
      // Errores del servidor
      if (error.response.status === 401) {
        // Redirigir al login si no autorizado

        sessionStorage.setItem("auth",encriptar("false",tokenEncript))
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Sesion expirada inicie sesion nuevamente",
        });
        // window.location.href = '/';
      }
      // Otros errores de respuesta
      console.error('Error en la respuesta:', error.response.data);
    } else if (error.request) {
      // Errores de solicitud
      console.error('Error en la solicitud:', error.request);
    } else {
      // Errores de configuración
      console.error('Error al configurar la solicitud:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api;